import {createContext, useState} from 'react';
import {IntlProvider} from 'react-intl';
import en from '@assets/data/locales/en.json';
import ir from '@assets/data/locales/ir.json';

// Define messages object for different languages
const IntlProviderMessages = {
    en,
    ir
};

// Create context
const LocaleContext = createContext();

// Define IntlProviderWrapper component
const IntlProviderWrapper = ({children}) => {
    // Set initial state
    const [locale, setLocale] = useState('ir');

    // Switch language function
    const switchLanguage = lang => {
        setLocale(lang);
    };

    // Update messages when locale changes
    const translatedMessages = IntlProviderMessages[locale];

    return (
        <LocaleContext.Provider value={{locale, switchLanguage}}>
            <IntlProvider
                key={locale}
                locale={locale}
                messages={translatedMessages}
                defaultLocale='ir'
            >
                {children}
            </IntlProvider>
        </LocaleContext.Provider>
    );
};

// Export context and IntlProviderWrapper component
export {LocaleContext as default, IntlProviderWrapper};
